import { InputAdornment, Unstable_Grid2 as Grid } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import {
  TextField,
  ToggleButtonGroupField,
  CurrencyInputField,
  ProductGroupSelectField,
} from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { TRANSACTION_DISCOUNT_TYPE, TransactionDiscountValues } from '../../../types';

const purchaseAmountThresholdInputProps = {
  'data-testid': 'transaction-discount-purchase',
};

type TransactionDiscountFormContentProps = {
  values: TransactionDiscountValues;
};

const awardTypes = [
  { title: 'percent', value: TRANSACTION_DISCOUNT_TYPE.PERCENT },
  { title: 'dollars', value: TRANSACTION_DISCOUNT_TYPE.DOLLARS },
];

export const TransactionDiscountFormContent = ({ values }: TransactionDiscountFormContentProps) => {
  const endAdornment =
    values?.transactionDiscount?.type === TRANSACTION_DISCOUNT_TYPE.PERCENT ? (
      <InputAdornment position='end'>%</InputAdornment>
    ) : null;

  const renderField = () => {
    const nameValue = 'transactionDiscount.amount';
    const inputProps = {
      'data-testid': 'transaction-discount-amount',
    };

    if (values?.transactionDiscount?.type === TRANSACTION_DISCOUNT_TYPE.DOLLARS) {
      return (
        <CurrencyInputField
          name={nameValue}
          fieldProps={{
            parse: undefined,
          }}
          inputProps={inputProps}
        />
      );
    }

    return (
      <TextField
        type='number'
        name={nameValue}
        InputProps={{
          endAdornment,
        }}
        fieldProps={{
          parse: parseNumber,
        }}
        inputProps={inputProps}
      />
    );
  };

  return (
    <div data-testid='transaction-discount-form'>
      <Grid container>
        <Grid xs={12}>
          <Typography variant='subtitle1' paragraph>
            Give members
          </Typography>
        </Grid>
        <Grid container columnSpacing={3} xs={12}>
          <Grid xs='auto'>
            <ToggleButtonGroupField name='transactionDiscount.type' buttons={awardTypes} />
          </Grid>
          <Grid xs={3}>{renderField()}</Grid>
        </Grid>
      </Grid>

      <Grid container sx={{ pt: 2 }}>
        <Grid xs={12}>
          <Typography variant='subtitle1' paragraph>
            When they spend at least
          </Typography>
        </Grid>
        <Grid xs={3}>
          <CurrencyInputField
            name='transactionDiscount.purchaseAmountThreshold'
            label='Dollar(s)'
            inputProps={purchaseAmountThresholdInputProps}
          />
        </Grid>
      </Grid>

      <Grid container sx={{ pt: 2 }}>
        <Grid xs={12}>
          <Typography variant='subtitle1' paragraph>
            Excluding the following:
          </Typography>
        </Grid>
        <Grid xs={12}>
          <ProductGroupSelectField
            inputProps={{
              margin: 'none',
            }}
            name='transactionDiscount.productGroups'
            label='Product groups'
          />
        </Grid>
      </Grid>
    </div>
  );
};
